module.exports = __webpack_public_path__ + "static/scale-model-of-chabot-space-&-science-center-in-oakland-california-185818fa33129279efc9402bfa8b555a.png";